import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadSalesTeams = async () => {
  try {
    const response = await Axios.get('sales-teams');
    const responseData = await response.data;
    return responseData;
    // return []
  }catch (err) {
    throw err;
  }
};


const loadOne = async (name) => {
  try {
    const respnse = await Axios.get('sales-teams/find/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadSalesTeam = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/sales-teams');
        const responseData = await response.data;
        return {...responseData, salesTeam: {}};
        // return {taxes: [], products: [], contacts:[], operationTypes:[], quotation:{}};
        
      default:
        const data = await loadOne(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useSalesTeamAPI = () => {
  const { success, error } = useOutletContext();


  const create = async (data) => {
    try {
      const respnse = await Axios.post('sales-teams', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('sales_team_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  }

  const update = async (seo, data) => {
    try {
      const respnse = await Axios.put('sales-teams/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('sales_team_response', data.seo);
    }catch (err) {
      throw err;
    }
  }

  return { create, update };
};



export default useSalesTeamAPI;


